import {
  CANCER_ASSESSMENT_FORM,
  CONSENT_FORM_UPLOAD,
  GET_CANCER_ASSESSMENT,
  GET_CANCER_FILE,
  GET_CANCER_SCREENING_OBSERVATION,
  GET_CANCER_SCREENING_VISITS,
  GET_UPLOAD_CONSENT,
  POST_CVAT_ANNOTATE,
  SUMIT_CANCER_SCREENING,
  SUMIT_CANCER_SCREENING_DV,
  UPLOAD_CANCER_SCREENING,
} from '../utils/Endpoints'
import { CancerAssessmentFormPayload } from '../features/opd/components/CancerScreening/Constants'
import { CVATProps } from '../features/opd/components/CancerScreening/CancerScreening'
import { archiveVisit, deleteVisit, LABS_PROJECT_ID } from '../utils/constants'
import { intentLab } from '../features/lms/models'
import { startSxpProxy } from '../utils/api'
import HttpService from '../utils/httpService'
import KeycloakService from '../utils/keycloakService'
import axios from 'axios'

// Get the configured axios client with token refresh interceptor
// This automatically handles token refresh before each request
const axiosClient = HttpService.getAxiosClient()

export const postCancerScreeningFile = async (
  type: string,
  patientId: string,
  visitId: string,
  typeOfConsultation: string,
  status: string,
  files?: File[] | any,
  acetonicImage?: File | any,
  iodineImage?: File | any,
  observationId?: string
) => {
  try {
    const formData = new FormData()

    if (files && files?.length) {
      files?.forEach((f: File) => {
        formData.append('files', f)
      })
    }

    if (acetonicImage) {
      formData.append('aceticImage', acetonicImage)
    }

    if (iodineImage) {
      formData.append('iodineImage', iodineImage)
    }
    if (observationId) {
      formData.append('observationId', observationId)
    }

    formData.append('type', type)
    formData.append('patientId', patientId)
    formData.append('visitId', visitId)
    formData.append('typeOfConsultation', typeOfConsultation)
    formData.append('status', status)

    const response: any = await axiosClient.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UPLOAD_CANCER_SCREENING}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const postCancerScreeningResultStepTwo = async (
  observationId: string,
  fhirPatientId: string,
  approved: boolean,
  visitId: string,
  categorizationDv: string,
  accuracyDv: string,
  interpretationAi: string,
  furtherInterpretationRequired: boolean,
  status: string,
  typeOfConsultation: string,
  imageSelection: Array<Record<string, string>>
) => {
  const myHeaders = {
    'Content-Type': 'application/json',
  }

  try {
    const response: any = await axiosClient.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${SUMIT_CANCER_SCREENING}?observationId=${observationId}&visitId=${visitId}&interpretationAi=${interpretationAi}&categorizationDv=${categorizationDv}&accuracyDv=${accuracyDv}&approved=${approved}&furtherInterpretationRequired=${furtherInterpretationRequired}&fhirPatientId=${fhirPatientId}&status=${status}&typeOfConsultation=${typeOfConsultation}`,
      imageSelection,
      { headers: myHeaders }
    )

    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const postCancerScreeningResultStepThree = async (
  type: string,
  patientId: string,
  visitId: string,
  observationId: string,
  fhirPatientId: string,
  interpretationDv: string,
  status: string,
  typeOfConsultation: string,
  files?: Record<string, File> | any
) => {
  try {
    const formData = new FormData()

    // Append files with specific keys
    if (files && typeof files === 'object') {
      Object?.keys(files)?.forEach((key) => {
        if (files[key]) {
          formData?.append(key, files[key])
        }
      })
    }
    formData.append('fhirPatientId', fhirPatientId)
    formData.append('observationId', observationId)
    formData.append('interpretationDv', interpretationDv)
    formData.append('type', type)
    formData.append('patientId', patientId)
    formData.append('visitId', visitId)
    formData.append('status', status)
    formData.append('typeOfConsultation', typeOfConsultation)

    const response: any = await axiosClient.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${SUMIT_CANCER_SCREENING_DV}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const postCancerScreeningResultDv = async (
  type: string,
  patientId: string,
  visitId: string,
  interpretationDv: string,
  file?: File | any
) => {
  try {
    const formData = new FormData()

    if (file) {
      formData.append('file', file)
    }
    formData.append('type', type)
    formData.append('patientId', patientId)
    formData.append('visitId', visitId)
    formData.append('interpretationDv', interpretationDv)

    const response: any = await axiosClient.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${SUMIT_CANCER_SCREENING}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const getCancerScreeningFile = async (fileName: string) => {
  try {
    const response: any = await axiosClient.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_CANCER_FILE}${fileName}`,
      {
        responseType: 'blob',
      }
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'File fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to fetch file',
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const getCancerScreeningObservation = async (visitId: string) => {
  try {
    const response: any = await axiosClient.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_CANCER_SCREENING_OBSERVATION}${visitId}`
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

// assessment

export const uploadConsentForm = async (file: File | null, muhid: string) => {
  try {
    const formdata = new FormData()
    if (file) {
      formdata.append('file', file, file?.name)
      formdata.append('muhId', muhid)
    }

    const response = await axiosClient.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CONSENT_FORM_UPLOAD}`,
      formdata
    )

    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const submitCancerAssessmentForm = async (
  payload: CancerAssessmentFormPayload
) => {
  try {
    const response = await axiosClient.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CANCER_ASSESSMENT_FORM}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const getCancerAssessmentStatus = async (muhid: string) => {
  try {
    const response = await axiosClient.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_CANCER_ASSESSMENT}${muhid}`
    )

    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const getUploadConsentFormStatus = async (muhid: string) => {
  try {
    const response = await axiosClient.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_UPLOAD_CONSENT}${muhid}`
    )

    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

// assessment

// Consent

export const fetchImage = async (documentNameAi: string) => {
  const fileResponse = await getCancerScreeningFile(documentNameAi)
  if (fileResponse?.success) {
    const file = new File([fileResponse?.data], documentNameAi, {
      type: fileResponse?.data?.type,
    })
    const imageUrl = URL.createObjectURL(fileResponse?.data)
    return {
      url: imageUrl,
      file: file,
    }
  }
}

// Consent

export const getCancerScreeningVisits = async (
  page: number,
  size: number,
  isDoctor: boolean,
  filters?: string
) => {
  try {
    const response: any = await axiosClient.get(
      `${
        process.env.REACT_APP_API_GATEWAY_URL
      }${GET_CANCER_SCREENING_VISITS}?doctor=${isDoctor}&page=${page}&size=${size}${
        filters && `&filters=${filters}`
      }`
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const postCVAT = async (payload: CVATProps) => {
  try {
    const response = await axiosClient.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${POST_CVAT_ANNOTATE}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}
export const deleteVisitId = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${deleteVisit}${data}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const archiveVisitId = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${archiveVisit}${data}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const opdLabOrderService = async (
  patientId: any,
  limit: number,
  offset: number
) => {
  try {
    const state = {
      patientId: patientId,
      limit: limit,
      offset: offset,
    }
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      intentLab?.newLabOrdersByPatientIdAndStatus,
      state
    )
    if (response?.data?.lab_orders?.length) {
      return {
        success: true,
        data: response?.data,
      }
    } else {
      return {
        success: false,
        data: [],
      }
    }
  } catch (error) {
    console.log('Error in fetching Lab Orders', error)
    return {
      success: false,
      data: [],
    }
  }
}
